import {
    Page,
    Button,
    Card,
    Text,
    RadioButton,
    Layout,
    Spinner,
    LegacyCard,
    List,
    Link,
    Tabs,
    ButtonGroup, CalloutCard
} from "@shopify/polaris";
import React, {useCallback, useEffect, useState} from "react";
import {Redirect} from "@shopify/app-bridge/actions";
import Http from "../../Lib/Http";
import Stepper from "./Stepper"
import PageDivider from "../../components/PageDivider";
import {Plan} from "../../types";
import Alert from "@admin/Lib/Alert";

function Style() {
    const [baseURL, setBaseURL] = useState<string | null>(null);
    const [loading, setLoading] = useState(false);
    const [installTypeSelected, setInstallTypeSelected] = useState(false);
    const [legacy, setLegacy] = useState(false);
    const [installType, setInstallType] = useState<string | null>('0');
    const [paidPlan, setPaidPlan] = useState<Plan | null>(null);
    const [appBlockLiveLink, setAppBlockLiveLink] = useState<string | null>(null);
    const [canAutoInstall, setCanAutoInstall] = useState<boolean>(false);
    const [hasAppBlocks, setHasAppBlocks] = useState<boolean>(false);
    const [selected, setSelected] = useState(0);
    const urlParams = new URLSearchParams(window.location.search);
    const isSettings = urlParams.get('settings') === '1';


    const switchPlan = (planID :number) => {

    }

    useEffect(() => {
        getShops();
    }, []);


    const handleTabChange = useCallback(
        (selectedTabIndex: number) => setSelected(selectedTabIndex),
        [],
    );


    const tabs = [
        {
            id: 'Inline',
            content: 'Inline',
            accessibilityLabel: 'Inline',
            panelID: 'Inline',
        },
        {
            id: 'Popup Link',
            content: 'Popup Link',
            panelID: 'Popup-Link',
        },
        {
            id: 'Popup Button',
            content: 'Popup Button',
            panelID: 'Popup-Button',
        }
    ];


    const getShops = () => {
        setLoading(true) ;

        Http.get(`/app/api/v1/shop.json`)
            .then((response) => {
                console.log(response.data.shop);
                setInstallType(String(response.data.shop.styled));
                setLoading(false) ;

            })
            .catch((error) => {
                console.error('Error fetching data:', error);
                setLoading(false) ;
            });
    };


    const selectInstallType = (type: string) => {
        setInstallType(type);
    };


    const next = () => {
        setLoading(true);
         Http.post('/app/api/v1/styling', {
            styled: installType,
        }).then(() => {
            Alert.success("Style saved");

            setLoading(false);

            if(!isSettings){
                let redirect = Redirect.create(window.app);
                redirect.dispatch(Redirect.Action.APP, '/app/wizard/5');
            }

        }).catch((error) => {
            setLoading(false);
        });
    };

    const goTo = (location: string) => {
        let redirect = Redirect.create(window.app);
        redirect.dispatch(Redirect.Action.APP, '/app' + location);
    }

    return (
        <Page
            {...(isSettings && {
                backAction: {content: 'Home', onAction() {goTo('')}},
                title: "Enable or Disable Pre-Styled Charts"
            })}
        >
            <Layout>
                {!isSettings &&
                <Layout.Section>
                    <Stepper currentStep={3}/>
                </Layout.Section>
                }
                {!isSettings &&
                    <Layout.Section>
                        <Card>
                            <div className="nbis-center mb-10 mt-20">
                                <Text variant="headingLg" as="h5">
                                    Choose Your Chart Styling
                                </Text>
                            </div>
                        </Card>
                    </Layout.Section>
                }
                {loading && (
                    <Layout.Section>
                        <div style={{display: 'flex', justifyContent: 'center', paddingBottom: '15px'}}>
                            <Spinner accessibilityLabel="Loading" size="large"/>
                        </div>
                    </Layout.Section>
                )}
                    <Layout.Section variant="oneHalf">
                        <Card>
                            <div style={{display: 'flex', justifyContent: 'center', paddingBottom: '15px'}}>
                                <RadioButton
                                    checked={installType === '0'}
                                    onChange={() => selectInstallType('0')}
                                    name="installType"
                                    value="os2"
                                    label="Unstyled"
                                />
                            </div>
                            <div>
                                <p style={{textAlign: 'center'}}>
                                    Use your store’s default theme styling. No additional CSS will be applied to the size chart.
                                    Chart will inherit styling from your theme.
                                        <br/>
                                    <br/>
                                </p>
                            </div>
                        </Card>

                    </Layout.Section>
                    <Layout.Section variant="oneHalf">
                        <Card>
                            <div style={{display: 'flex', justifyContent: 'center', paddingBottom: '15px'}}>
                                <RadioButton
                                    checked={installType === '1'}
                                    onChange={() => selectInstallType('1')}
                                    name="installType"
                                    value="manual"
                                    label="Styled"
                                />
                            </div>
                            <div>
                                <p style={{textAlign: 'center'}}>
                                    Apply enhanced styling for a more visually appealing size chart, including centered text, colored rows, and improved table formatting.
                                    <br/><br/>
                                </p>
                            </div>
                        </Card>
                    </Layout.Section>


                <Layout.Section>
                    <Card>
                        <div style={{display: 'flex', justifyContent: 'center', paddingBottom: '15px'}}>
                            <ButtonGroup>
                                {!isSettings &&
                                    <Button onClick={() => setInstallTypeSelected(false)}>
                                        Go back
                                    </Button>
                                }

                                {!isSettings &&
                                    <Button onClick={next} variant="primary">
                                        Save & Continue
                                    </Button>
                                }

                                {isSettings &&
                                    <Button onClick={next} variant="primary">
                                        Save
                                    </Button>
                                }


                            </ButtonGroup>
                        </div>
                    </Card>
                </Layout.Section>
            </Layout>
            <div style={{paddingBottom: '25px'}}></div>

        </Page>
    );
}

export default Style;
